import React, { useEffect } from "react";
import LandingHeader from "@/components/landing/LandingHeader";
import Hero from "@/components/landing/Hero";
import InstantTrial from "@/components/landing/InstantTrial";
import FeatureGrid from "@/components/landing/FeatureGrid";
import PricingPreview from "@/components/landing/PricingPreview";
import Testimonials from "@/components/landing/Testimonials";
import CTASection from "@/components/landing/CTASection";
import LandingFooter from "@/components/landing/LandingFooter";

export default function Landing() {
  // Reveal-on-scroll: add .visible to any [data-reveal] when it enters the viewport
  useEffect(() => {
    const els = document.querySelectorAll("[data-reveal]");
    els.forEach((el) => el.classList.add("reveal"));
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-[#05050A] text-white overflow-x-hidden">
      <LandingHeader />
      <Hero />
      <InstantTrial />
      <FeatureGrid />
      <PricingPreview />
      <Testimonials />
      <CTASection />
      <LandingFooter />
    </div>
  );
}
